import { useContext } from 'react';

import WSHelperContext, { WSHelperContextValue } from 'src/contexts/WSHelperContext';

const useWSHelper = (): WSHelperContextValue => useContext(WSHelperContext);

export default useWSHelper;
